/* eslint-disable */
export default {
  title: '歷史記錄',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
